import CustomerComments from './CustomerComments';

export default CustomerComments;
